import React from 'react';
import { CollapsibleRow } from '../../components/ui/primitives/Collapsible';

interface SequencerStepsCollapsibleProps {
  items: string[];
  expandedIndex: number;
  onExpandedChange: (index: number) => void;
  onItemChange: (index: number, text: string) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
}

function previewText(text: string, max = 48): string {
  const t = text.trim();
  if (!t) return 'Sin texto';
  return t.length > max ? `${t.slice(0, max)}…` : t;
}

export function SequencerStepsCollapsible({
  items,
  expandedIndex,
  onExpandedChange,
  onItemChange,
  onAdd,
  onRemove,
}: SequencerStepsCollapsibleProps) {
  return (
    <div className="studio-steps-panel">
      <div className="studio-steps-panel__head">
        <div>
          <p className="studio-zone__label">Pasos</p>
          <p className="studio-zone__hint">{items.length} ítems · expande uno para editar</p>
        </div>
        <button type="button" className="studio-rail-btn" onClick={onAdd}>
          + Paso
        </button>
      </div>

      <div className="studio-steps-panel__list">
        {items.map((text, index) => (
          <CollapsibleRow
            key={index}
            index={index}
            open={expandedIndex === index}
            onOpenChange={(open) => {
              if (open) onExpandedChange(index);
            }}
            title={previewText(text, 36)}
            subtitle={previewText(text, 64)}
          >
            <textarea
              className="canvas-inline-input w-full resize-y text-sm"
              rows={3}
              value={text}
              placeholder={`Texto del paso ${index + 1}`}
              onChange={(e) => onItemChange(index, e.target.value)}
            />
            {items.length > 2 && (
              <button
                type="button"
                className="mt-2 text-[10px] font-semibold text-red-400 hover:text-red-300"
                onClick={() => onRemove(index)}
              >
                Eliminar paso
              </button>
            )}
          </CollapsibleRow>
        ))}
      </div>
    </div>
  );
}
